import { useMutation, useQueryClient } from '@ltvco/refresh-lib/vendors';
import { AppConfig } from '@ltvco/refresh-lib/ctx';
import { ReactivateWithPlanChangeParams } from 'api/requests/reactivateWithPlanChange/interfaces';
import reactivateWithPlanChange from 'api/requests/reactivateWithPlanChange/reactivateWithPlanChange';
import { useContext } from 'react';
import { enqueueSnackbar } from '@ltvco/refresh-lib/v1';
import { CookiesStorage } from '@ltvco/refresh-lib';

export const useReactivateWithPlanChange = () => {
  const cookieStorage = new CookiesStorage();

  const { logError } = useContext(AppConfig);

  const queryClient = useQueryClient();

  const reactivateWithPlanChangeMutation = useMutation({
    mutationFn: (params: ReactivateWithPlanChangeParams) => {
      return reactivateWithPlanChange(params.planId);
    },
    onSuccess: () => {
      enqueueSnackbar('Bumper Garage enabled', {
        variant: 'success',
        autoHideDuration: 3000,
      });

      queryClient.invalidateQueries({
        queryKey: ['account'],
      });

      if (cookieStorage.getValue('free_activation_redirect')) {
        cookieStorage.removeValue('free_activation_redirect');
      }
    },
    onError: (err: Error) => {
      logError('Failed to reactivate with plan change', err as Error);
      enqueueSnackbar('Reactivation unsuccessful', {
        variant: 'error',
        autoHideDuration: 3000,
      });
    },
  });

  return {
    reactivateWithPlanChangeMutation,
  };
};
